var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal dm-modal",
      attrs: {
        id: "dm-default-modal",
        tabindex: "-1",
        role: "dialog",
        "aria-labelledby": "dm-default-modal-title",
        "aria-hidden": "true"
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-dialog modal-dialog-centered",
          class: _vm.modalSize,
          attrs: { role: "document" }
        },
        [
          _c("div", { staticClass: "modal-content" }, [
            _vm.title
              ? _c("div", { staticClass: "modal-header" }, [
                  _c(
                    "h2",
                    {
                      staticClass: "modal-title w-100 h4",
                      attrs: { id: "dm-default-modal-title" }
                    },
                    [_vm._v(_vm._s(_vm.title))]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "dm-close-modal d-flex align-items-center" },
                    [
                      !_vm.hide_close_btn
                        ? _c(
                            "button",
                            {
                              staticClass:
                                "dm-svg-button dm-transparent dm-dark",
                              attrs: {
                                type: "button",
                                "data-bs-dismiss": "modal",
                                "aria-label": "Close",
                                title: "Close"
                              }
                            },
                            [_c("svg-icon", { attrs: { icon: "close" } })],
                            1
                          )
                        : _vm._e()
                    ]
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body" }, [_vm._t("default")], 2)
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }